import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import StaffContactTypes from "./ContactTypes";
import StaffAddressTypes from "./AddressTypes";
import ShiftDefaultsPanel from "../../components/ShiftDefaultsPanel";
import { Link } from "react-router-dom";
import InfoCard from "../../../../Components/Common/InfoCard/InfoCard";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";
import {
  addStaffLeaveType,
  addStaffLeaveTypeSuccess,
  createStaffIncomeCategoryItem,
  createStaffIncomeCategoryItemSuccess,
  createStaffSkillSet,
  createStaffSkillSetSuccess,
  deleteStaffIncomeCategoryItem,
  deleteStaffIncomeCategoryItemSuccess,
  deleteStaffLeaveType,
  deleteStaffLeaveTypeSuccess,
  deleteStaffSkillSet,
  deleteStaffSkillSetSuccess,
  getStaffIncomeCategoryItemList,
  getStaffLeaveTypeList,
  getStaffSkillSetList,
  updateStaffIncomeCategoryItem,
  updateStaffIncomeCategoryItemSuccess,
  updateStaffLeaveType,
  updateStaffLeaveTypeSuccess,
  updateStaffSkillSet,
  updateStaffSkillSetSuccess,
} from "../../../../store/staff/action";
export default function StaffSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const {
    staffLeaveTypeListAPI,
    staffIncomeCategoryItemListAPI,
    gettingStaffSkillSetListAPI,
  } = useSelector((state) => ({
    staffLeaveTypeListAPI: state.Staff.staffLeaveTypeList?.staffleavetype_list,
    staffIncomeCategoryItemListAPI:
      state.Staff.staffIncomeCategoryItemList?.staffincomeitemcategory_list,
    gettingStaffSkillSetListAPI:
      state.Staff.gettingStaffSkillSetList?.staffskillset_list,
  }));

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(addStaffLeaveType([createStatus]));
    }
    if (activeTab === "2") {
      //   Income Category create
      dispatch(createStaffIncomeCategoryItem([createStatus]));
    }
    if (activeTab === "3") {
      dispatch(createStaffSkillSet([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = staffLeaveTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      data = staffIncomeCategoryItemListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "3") {
      data = gettingStaffSkillSetListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [
    staffLeaveTypeListAPI,
    staffIncomeCategoryItemListAPI,
    activeTab,
    gettingStaffSkillSetListAPI,
  ]);

  useEffect(() => {
    dispatch(getStaffLeaveTypeList());
    dispatch(getStaffIncomeCategoryItemList());
    dispatch(getStaffSkillSetList());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Leave Types",
    },
    {
      id: "2",
      name: "Income Categories",
    },
    {
      id: "3",
      name: "Skills",
    },
    // Task 24467 - the customisable labels staff contact points can carry.
    {
      id: "4",
      name: "Contact Types",
    },
    // Task 24857 - the company defaults a new shift on the Staff Planner opens
    // with. They were config items with no screen, editable only by typing into
    // the generic Config Items grid.
    {
      id: "5",
      name: "Shift Defaults",
    },
    // Task 24860 - the labels a staff address can carry, and which kinds of
    // address the Shift Planner should measure from.
    {
      id: "6",
      name: "Address Types",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deleteStaffLeaveType([deleteStatus]));
    }
    if (activeTab === "2") {
      // Income Category delete
      dispatch(deleteStaffIncomeCategoryItem([deleteStatus]));
    }
    if (activeTab === "3") {
      // Skill Set delete
      dispatch(deleteStaffSkillSet([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updateStaffLeaveType([updateNewStatus]));
      }
      if (activeTab === "2") {
        //  Income Category update
        dispatch(updateStaffIncomeCategoryItem([updateNewStatus]));
      }
      if (activeTab === "3") {
        //  Skill Set update
        dispatch(updateStaffSkillSet([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  //Effects
  const {
    addStaffLeaveTypeSuccessAPI,
    updateStaffLeaveTypeSuccessAPI,
    deleteStaffLeaveTypeSuccessAPI,
    createStaffIncomeCategoryItemSuccessAPI,
    updateStaffIncomeCategoryItemSuccessAPI,
    deleteStaffIncomeCategoryItemSuccessAPI,
    createStaffSkillSetSuccessAPI,
    updateStaffSkillSetSuccessAPI,
    deleteStaffSkillSetSuccessAPI,
  } = useSelector((state) => ({
    addStaffLeaveTypeSuccessAPI: state.Staff.addStaffLeaveTypeSuccess,
    updateStaffLeaveTypeSuccessAPI: state.Staff.updateStaffLeaveTypeSuccess,
    deleteStaffLeaveTypeSuccessAPI: state.Staff.deleteStaffLeaveTypeSuccess,
    createStaffIncomeCategoryItemSuccessAPI:
      state.Staff.createStaffIncomeCategoryItemSuccess,
    updateStaffIncomeCategoryItemSuccessAPI:
      state.Staff.updateStaffIncomeCategoryItemSuccess,
    deleteStaffIncomeCategoryItemSuccessAPI:
      state.Staff.deleteStaffIncomeCategoryItemSuccess,
    createStaffSkillSetSuccessAPI: state.Staff.createStaffSkillSetSuccess,
    updateStaffSkillSetSuccessAPI: state.Staff.updateStaffSkillSetSuccess,
    deleteStaffSkillSetSuccessAPI: state.Staff.deleteStaffSkillSetSuccess,
  }));

  // Effects add new leave type
  useEffect(() => {
    if (isEmpty(addStaffLeaveTypeSuccessAPI)) return;
    if (addStaffLeaveTypeSuccessAPI?.status === 200) {
      toast.success(addStaffLeaveTypeSuccessAPI?.message);
      dispatch(getStaffLeaveTypeList());
    } else {
      toast.error(addStaffLeaveTypeSuccessAPI?.message);
    }
    dispatch(addStaffLeaveTypeSuccess([]));
  }, [addStaffLeaveTypeSuccessAPI]);

  // Effects update leave type
  useEffect(() => {
    if (isEmpty(updateStaffLeaveTypeSuccessAPI)) return;
    if (updateStaffLeaveTypeSuccessAPI?.status === 200) {
      toast.success(updateStaffLeaveTypeSuccessAPI?.message);
      dispatch(getStaffLeaveTypeList());
    } else {
      toast.error(updateStaffLeaveTypeSuccessAPI?.message);
    }
    dispatch(updateStaffLeaveTypeSuccess([]));
  }, [updateStaffLeaveTypeSuccessAPI]);

  // Effects delete leave type
  useEffect(() => {
    if (isEmpty(deleteStaffLeaveTypeSuccessAPI)) return;
    if (deleteStaffLeaveTypeSuccessAPI?.status === 200) {
      toast.success(deleteStaffLeaveTypeSuccessAPI?.message);
      dispatch(getStaffLeaveTypeList());
      setDeleteModal(false);
    } else {
      toast.error(deleteStaffLeaveTypeSuccessAPI?.message);
    }
    dispatch(deleteStaffLeaveTypeSuccess([]));
  }, [deleteStaffLeaveTypeSuccessAPI]);

  // Effects add new income category
  useEffect(() => {
    if (isEmpty(createStaffIncomeCategoryItemSuccessAPI)) return;
    if (createStaffIncomeCategoryItemSuccessAPI?.status === 200) {
      toast.success(createStaffIncomeCategoryItemSuccessAPI?.message);
      dispatch(getStaffIncomeCategoryItemList());
    } else {
      toast.error(createStaffIncomeCategoryItemSuccessAPI?.message);
    }
    dispatch(createStaffIncomeCategoryItemSuccess([]));
  }, [createStaffIncomeCategoryItemSuccessAPI]);

  // Effects update income category
  useEffect(() => {
    if (isEmpty(updateStaffIncomeCategoryItemSuccessAPI)) return;
    if (updateStaffIncomeCategoryItemSuccessAPI?.status === 200) {
      toast.success(updateStaffIncomeCategoryItemSuccessAPI?.message);
      dispatch(getStaffIncomeCategoryItemList());
    } else {
      toast.error(updateStaffIncomeCategoryItemSuccessAPI?.message);
    }
    dispatch(updateStaffIncomeCategoryItemSuccess([]));
  }, [updateStaffIncomeCategoryItemSuccessAPI]);

  // Effects delete income category
  useEffect(() => {
    if (isEmpty(deleteStaffIncomeCategoryItemSuccessAPI)) return;
    if (deleteStaffIncomeCategoryItemSuccessAPI?.status === 200) {
      toast.success(deleteStaffIncomeCategoryItemSuccessAPI?.message);
      dispatch(getStaffIncomeCategoryItemList());
      setDeleteModal(false);
    } else {
      toast.error(deleteStaffIncomeCategoryItemSuccessAPI?.message);
    }
    dispatch(deleteStaffIncomeCategoryItemSuccess([]));
  }, [deleteStaffIncomeCategoryItemSuccessAPI]);

  //createStaffSkillSetSuccessAPI
  useEffect(() => {
    if (isEmpty(createStaffSkillSetSuccessAPI)) return;
    if (createStaffSkillSetSuccessAPI?.status === 200) {
      toast.success(createStaffSkillSetSuccessAPI?.message);
      dispatch(getStaffSkillSetList());
    } else {
      toast.error(createStaffSkillSetSuccessAPI?.message);
    }
    dispatch(createStaffSkillSetSuccess([]));
  }, [createStaffSkillSetSuccessAPI]);

  //updateStaffSkillSetSuccessAPI
  useEffect(() => {
    if (isEmpty(updateStaffSkillSetSuccessAPI)) return;
    if (updateStaffSkillSetSuccessAPI?.status === 200) {
      toast.success(updateStaffSkillSetSuccessAPI?.message);
      dispatch(getStaffSkillSetList());
    } else {
      toast.error(updateStaffSkillSetSuccessAPI?.message);
    }
    dispatch(updateStaffSkillSetSuccess([]));
  }, [updateStaffSkillSetSuccessAPI]);
  //deleteStaffSkillSetSuccessAPI
  useEffect(() => {
    if (isEmpty(deleteStaffSkillSetSuccessAPI)) return;
    if (deleteStaffSkillSetSuccessAPI?.status === 200) {
      toast.success(deleteStaffSkillSetSuccessAPI?.message);
      dispatch(getStaffSkillSetList());
      setDeleteModal(false);
    } else {
      toast.error(deleteStaffSkillSetSuccessAPI?.message);
    }
    dispatch(deleteStaffSkillSetSuccess([]));
  }, [deleteStaffSkillSetSuccessAPI]);
  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Staff Settings"
        description="Leave types, income categories, skills, contact and address types, and the billing defaults a new shift opens with."
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        {/* Contact Types manages its own CRUD. The other three tabs share
            StatusViewEditComponent, which is driven by activeTab branches in
            six places; this lookup also carries colours and an active flag they
            do not, so it is kept separate rather than threaded through. */}
        {activeTab === "1" ? (
          // Task 24479 - leave types moved to Settings > Staff Leave, which is
          // where people go looking for them. Pointing here rather than keeping
          // a second editor: two screens editing one table is how they end up
          // looking like they might differ.
          <InfoCard
            title="Leave types have moved"
            icon="ri-arrow-right-circle-line"
            accent="indigo"
          >
            <p className="mb-3">
              They are now managed under <strong>Staff Leave</strong>, alongside
              the holiday calendars and restriction periods they work with.
            </p>
            <Link to="/settings/1/29/leave-types" className="btn btn-primary">
              <i className="ri-external-link-line align-bottom me-1" />
              Go to Leave Types
            </Link>
          </InfoCard>
        ) : activeTab === "4" ? (
          <StaffContactTypes />
        ) : activeTab === "5" ? (
          <ShiftDefaultsPanel />
        ) : activeTab === "6" ? (
          <StaffAddressTypes />
        ) : (
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
          />
        )}
      </SettingsPanel>
    </>
  );
}
